if (!customElements.get("ff-slider-block")) {
  class FFSliderBlock extends HTMLElement {
    connectedCallback() {
      this.ffSwiperEl = this.querySelector(".swiper");
      this.ffWrapper = this.ffSwiperEl.querySelector(".swiper-wrapper");
      const ffOptions = JSON.parse(this.querySelector("[data-ff-slider-options]").textContent);

      // Theme blocks render inside Shopify's own wrapper, so the slide class can't be set in Liquid.
      [...this.ffWrapper.children].forEach((el) => el.classList.add("swiper-slide"));

      if (ffOptions.loop && !this.ffHasEnoughSlidesForLoop(ffOptions)) ffOptions.loop = false;

      this.ffSwiper = new Swiper(this.ffSwiperEl, {
        ...ffOptions,
        // Swiper's default list includes `video`: once clicked (focused), dragging from it stops moving the slider.
        focusableElements: "input, select, option, textarea, button, label",
        navigation: {
          ...ffOptions.navigation,
          nextEl: this.ffSwiperEl.querySelector(":scope > .swiper-button-next"),
          prevEl: this.ffSwiperEl.querySelector(":scope > .swiper-button-prev"),
        },
        pagination: { ...ffOptions.pagination, el: this.ffSwiperEl.querySelector(":scope > .swiper-pagination") },
        on: { slideChange: this.ffPauseInactiveVideos },
      });

      if (window.Shopify?.designMode) {
        this.addEventListener("shopify:block:select", this.ffOnBlockSelect);
      }
    }

    disconnectedCallback() {
      this.ffSwiper?.destroy();
    }

    // Mirrors Swiper's own loop check; below it, loop leaves empty gaps and dragging jumps.
    ffHasEnoughSlidesForLoop(ffOptions) {
      const ffViews = [ffOptions.slidesPerView, ...Object.values(ffOptions.breakpoints || {}).map((bp) => bp.slidesPerView)];
      let ffNeeded = Math.ceil(Math.max(...ffViews));
      if (ffOptions.centeredSlides && ffNeeded % 2 === 0) ffNeeded += 1;
      return this.ffWrapper.children.length >= ffNeeded + 1;
    }

    ffPauseInactiveVideos = (swiper) => {
      const ffActiveSlide = swiper.slides[swiper.activeIndex];
      this.ffWrapper.querySelectorAll("video").forEach((video) => {
        if (!ffActiveSlide?.contains(video) && !video.autoplay) video.pause();
      });
    };

    ffOnBlockSelect = (event) => {
      const ffSlide = event.target.closest(".swiper-slide");
      if (ffSlide?.parentElement !== this.ffWrapper) return;
      const ffIndex = this.ffSwiper.params.loop
        ? Number(ffSlide.dataset.swiperSlideIndex)
        : this.ffSwiper.slides.indexOf(ffSlide);
      this.ffSwiper.slideToLoop(ffIndex);
    };
  }

  customElements.define("ff-slider-block", FFSliderBlock);
}
